
export enum ReactionPlateState {
    WORK_IN_PROGRESS = "WORK_IN_PROGRESS",
    COMPLETE = "COMPLETE",
    REACTIONS_PLACED = "REACTIONS_PLACED"

}